module.exports = __webpack_public_path__ + "static/media/Closed Captions Test-Navico Welcome Video_1639673400787.7f0957f8.vtt";